export interface Testimonial {
  name: string
  location: string
  meta: string
  quote: string
  avatar: string
}

/** Contenido de ejemplo editable. */
export const testimonials: Testimonial[] = [
  {
    name: 'Carolina M.',
    location: 'Buenos Aires, Argentina',
    meta: 'Empezó como hobby',
    quote:
      'Había prensado flores antes y me salían marrones. Recién con la guía entendí que estaba usando el mismo método para todas. La segunda tanda salió con el color intacto.',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/390ee00a-1405-4ccc-9122-60846ab86842.jpg',
  },
  {
    name: 'Silvia R.',
    location: 'Santiago, Chile',
    meta: 'Vende sus piezas',
    quote:
      'Arranqué con marcapáginas para regalar y hoy vendo cuadros botánicos en ferias. Saber qué juntar en cada estación fue clave para tener stock antes de las fiestas.',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/7e6cef6d-9bd4-424a-99a9-f8c8a34ea3a3.jpg',
  },
  {
    name: 'Malena T.',
    location: 'Montevideo, Uruguay',
    meta: 'Lo hizo para regalar',
    quote:
      'Le hice a mi mamá un cuadro con las flores del jardín de mi abuela. Lloró. Ningún regalo comprado me había salido así.',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/44a50293-94a9-4e57-87bd-86bdcd8cd792.jpg',
  },
  {
    name: 'Graciela P.',
    location: 'Lima, Perú',
    meta: 'Jardinera de siempre',
    quote:
      'Tengo plantas desde siempre y aprendí cosas que no sabía: en qué momento del día cortar y por qué algunas flores nunca van a servir para prensar.',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/025d2483-9942-45f0-b998-0c08de3df101.jpg',
  },
  {
    name: 'Julieta A.',
    location: 'Bogotá, Colombia',
    meta: 'Primera vez con manualidades',
    quote:
      'Soy de empezar cosas y dejarlas. Esta vez terminé el primer proyecto en una tarde, y eso me dio ganas de seguir con el siguiente.',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/2cbb4af6-e9fd-4fe7-b7bc-057e793777f2.jpg',
  },
  {
    name: 'Romina L.',
    location: 'Ciudad de México, México',
    meta: 'Ingreso extra',
    quote:
      'Los dijes con flores prensadas se me venden solos en Instagram. El costo de material es mínimo comparado con lo que la gente paga.',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/434ef63d-7a44-4b38-a263-7c1158aa9ccc.jpg',
  },
  {
    name: 'Ana Clara S.',
    location: 'Rosario, Argentina',
    meta: 'Buscaba desconectar',
    quote:
      'Me siento una hora los domingos a acomodar pétalos y no pienso en nada más. Es lo más cerca de meditar que logré en años.',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/26210bc9-3cf4-4d73-85e5-856a308ad67e.jpg',
  },
]
